import { Link } from "react-router-dom";
import { Syringe, ShieldCheck, Baby, MapPin } from "lucide-react";
import { useSeo } from "@/lib/seo";
import { fileUrl } from "@/lib/api";
import { IMG } from "@/lib/content";
import { SectionTitle, Placeholder, Reveal } from "@/components/kit";
import { useFetch } from "@/components/shared";

export default function Campaign() {
  useSeo("Campagne de vaccination", "Campagne de vaccination dans les zones périphériques du Congo — Protégeons nos enfants, construisons l'avenir.");
  const media = useFetch("/media?structure=ong");
  const posters = (media || []).filter((m) => /vaccin/i.test(m.title));
  return (
    <div data-testid="campaign-page">
      <section className="relative overflow-hidden bg-ong text-white">
        <img src={IMG.health} alt="" className="absolute inset-0 h-full w-full object-cover opacity-20" />
        <div className="absolute inset-0 pagne-light" />
        <div className="container-x relative py-16 sm:py-24">
          <p className="fade-up font-display text-sm font-semibold uppercase tracking-[0.25em] text-gold">Campagne ONG MA LEBA</p>
          <h1 className="fade-up mt-3 max-w-4xl font-display text-4xl font-bold uppercase leading-none sm:text-5xl lg:text-6xl" style={{ animationDelay: ".1s" }}>
            Campagne de vaccination dans les zones périphériques du Congo
          </h1>
          <div className="fade-up mt-8 flex flex-wrap gap-3" style={{ animationDelay: ".25s" }}>
            <span className="rounded-full bg-gold px-5 py-2.5 font-display text-lg font-bold uppercase text-ink" data-testid="campaign-message-1">Protégeons nos enfants, construisons l'avenir</span>
            <span className="rounded-full border-2 border-white px-5 py-2.5 font-display text-lg font-bold uppercase" data-testid="campaign-message-2">Chaque vaccin, une vie sauvée</span>
          </div>
        </div>
      </section>
      <section className="pagne py-16">
        <div className="container-x grid gap-10 lg:grid-cols-3">
          {[[Syringe, "La campagne"], [MapPin, "Zones concernées"], [Baby, "Comment participer"]].map(([Icon, t], i) => (
            <Reveal key={t} delay={i * 0.08}>
              <div className="card h-full p-6">
                <Icon className="h-8 w-8 text-u" aria-hidden="true" />
                <h2 className="mt-4 font-display text-2xl font-bold uppercase text-ink">{t}</h2>
                <Placeholder className="mt-3" text="[Texte à compléter] — modifiable depuis le back-office (Actualités)." />
              </div>
            </Reveal>
          ))}
        </div>
      </section>
      <section className="container-x py-16">
        <SectionTitle eyebrow="Affiches" title="Supports de la campagne" className="mb-8" />
        {posters.length ? (
          <div className="grid gap-5 sm:grid-cols-2 lg:grid-cols-3">
            {posters.map((p) => <img key={p.id} src={fileUrl(p.url)} alt={p.title} loading="lazy" className="rounded-xl shadow-lg" />)}
          </div>
        ) : (
          <p className="text-neutral-600" data-testid="campaign-posters-empty">Les affiches de la campagne seront publiées prochainement (ajout depuis le back-office, Galerie, avec « vaccination » dans le titre).</p>
        )}
        <div className="mt-12 flex flex-wrap gap-3">
          <Link to="/contact" className="btn-u" data-testid="campaign-cta-contact"><ShieldCheck className="h-5 w-5" /> Soutenir la campagne</Link>
          <Link to="/ong/partenaires-etrangers" className="btn-outline text-u" data-testid="campaign-cta-partner">Devenir partenaire</Link>
        </div>
      </section>
    </div>
  );
}
